define('shared/initializer/form/adapters/mixins/fields/Email',[
    '$',
    '../../../constants',
    'shared/lib/RSVP'
], function (
    $,
    constants,
    RSVP
) {
    'use strict';

    function Ctor () {
    }

    var p = Ctor.prototype;

    p.doPageLoad = function() {
        var me = this;
        var fieldEmail = me.items[constants.FIELD.Email];
        if (fieldEmail && fieldEmail.$el) {
            fieldEmail.$el.attr('type', 'email');
            fieldEmail.$el.blur(function () {
                fieldEmail.$el.val(fieldEmail.$el.val().trim());
            });
        }
        return RSVP.resolve();
    };

    return Ctor;
});
